
const numberLength = (evt,leng) => {
  let val1 = evt.target.value;
  
  if ((val1.length > leng || evt.keyCode == 118)){
    evt.preventDefault();
  }
  
  if (!(evt.keyCode == 43 || (evt.keyCode >= 48 && evt.keyCode <= 57))) {
      evt.preventDefault();
  }
  // if ((evt.keyCode == 118 && val1.length <= leng) || evt.keyCode == 99) {
  if ((val1.length <= leng) || evt.keyCode == 99) {
        return evt.target.value;
  }

  
  if (evt.keyCode == 43 && (evt.target.selectionStart !== undefined && evt.target.selectionStart !== 0)) {
      evt.preventDefault();
  }
  return evt.target.value;
}

const decimalNumber = (e) => {
  const floating = /^[0-9.]\d*(\.\d{1,2})?$/;
  let char = String.fromCharCode(e.keyCode);
  if (floating.test(char)) return true;
  else e.preventDefault();
}

const NotZeroNumber = (evt,leng) => {
  let val1 = evt.target.value;
  
  if (evt.keyCode == 48 && val1.length == 0) {
      evt.preventDefault();
  }

  if ((evt.keyCode == 118 && val1.length <= leng) || evt.keyCode == 99) {
        return evt.target.value;
  }

  if (!(evt.keyCode == 43 || (evt.keyCode >= 48 && evt.keyCode <= 57))) {
      evt.preventDefault();
  }
  
  if (evt.keyCode == 43 && (evt.target.selectionStart !== undefined && evt.target.selectionStart !== 0)) {
      evt.preventDefault();
  }
  return evt.target.value;
}

const minMax = (evt,min,max) => {
  let val1 = evt.target.value;

  // const floating = /^(1[0-9]|[1-9]|2[0-0])$/;
  // let char = String.fromCharCode(evt.keyCode);
  // if (floating.test(char)) return true;
  // else evt.preventDefault();

  if (val1 > max || val1 < min) {
    evt.target.value = "";
    return false;
  }

  if ((evt.keyCode == 118 && val1 <= max) || (evt.keyCode == 118 && val1 >= min)) {
        return evt.target.value;
  }


  if (!(evt.keyCode == 43 || (evt.keyCode >= 48 && evt.keyCode <= 57))) {
      evt.preventDefault();
      evt.target.value = "";
      return false;
  }
  
  if (evt.keyCode == 43 && (evt.target.selectionStart !== undefined && evt.target.selectionStart !== 0)) {
      evt.preventDefault();
      evt.target.value = "";
      return false;
  }
  return true;
}


export {
  numberLength,
  decimalNumber,
  minMax,
  NotZeroNumber
};